import * as React from 'react';

import SearchMain from '../../components/SearchMain';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import i18n from '../../resources/i18n';
/**
 * 検索画面
 * @param props
 */
const Search: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('Search_0001')} />
			<SearchMain />
		</>
	);
};

export default Search;



// WEBPACK FOOTER //
// ./src/pages/personal/Search.tsx